import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import ReactGA from "react-ga4";
import App from "./App";
import "./index.css";
import "./css/app.css";
import "./instrument";
import "./utils/chartDefaults";

// Initialize Google Analytics
if (import.meta.env.VITE_GOOGLE_ANALYTICS_ID) {
  ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_ID);
}

// Tras un nuevo despliegue cambian los hashes de los chunks. Si el usuario tiene
// la SPA abierta desde una versión anterior y pide un chunk lazy (p.ej. exceljs),
// el fichero viejo ya no existe y Vite dispara "vite:preloadError". Recargamos
// una sola vez para servir la versión nueva, con guarda para evitar bucles.
window.addEventListener("vite:preloadError", () => {
  if (sessionStorage.getItem("vite-preload-reloaded") === "1") return;
  sessionStorage.setItem("vite-preload-reloaded", "1");
  window.location.reload();
});

const container = document.getElementById("app");
const root = createRoot(container, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(<App />);